import React from 'react';
import styled from 'styled-components';

// Professional: Clean pricing table with feature lists, corporate navy tones
const ProfessionalTheme = ({ colorTheme }: { colorTheme: string }) => {
   return (
      <Wrapper>
         <Table>
            <TableHead>
               <HeadCell>Plan</HeadCell>
               <HeadCell>Duration</HeadCell>
               <HeadCell>Price</HeadCell>
               <HeadCell></HeadCell>
            </TableHead>
            <TableRow>
               <Cell><PlanName>Basic</PlanName></Cell>
               <Cell><Duration>1 Hr</Duration></Cell>
               <Cell><Price>₱15</Price></Cell>
               <Cell><Btn>Select</Btn></Cell>
            </TableRow>
            <TableRow $highlight>
               <Cell>
                  <PlanName>Standard</PlanName>
                  <Popular>POPULAR</Popular>
               </Cell>
               <Cell><Duration>3 Hrs</Duration></Cell>
               <Cell><Price>₱50</Price></Cell>
               <Cell><BtnFilled>Select</BtnFilled></Cell>
            </TableRow>
            <TableRow>
               <Cell><PlanName>Premium</PlanName></Cell>
               <Cell><Duration>1 Day</Duration></Cell>
               <Cell><Price>₱80</Price></Cell>
               <Cell><Btn>Select</Btn></Cell>
            </TableRow>
            <TableRow>
               <Cell><PlanName>Enterprise</PlanName></Cell>
               <Cell><Duration>3 Days</Duration></Cell>
               <Cell><Price>₱150</Price></Cell>
               <Cell><Btn>Select</Btn></Cell>
            </TableRow>
         </Table>
      </Wrapper>
   );
};

const Wrapper = styled.div`
   background: #f8fafc; border-radius: 6px; padding: 6px;
`;
const Table = styled.div`display: flex; flex-direction: column;`;
const TableHead = styled.div`
   display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 4px;
   padding: 4px 6px; border-bottom: 1.5px solid #0f172a;
`;
const HeadCell = styled.span`font-size: 7px; font-weight: 700; color: #0f172a; text-transform: uppercase;`;
const TableRow = styled.div<{ $highlight?: boolean }>`
   display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 4px; align-items: center;
   padding: 5px 6px; border-bottom: 1px solid #e2e8f0;
   background: ${({ $highlight }) => $highlight ? '#f0f4ff' : 'transparent'};
`;
const Cell = styled.div`position: relative;`;
const PlanName = styled.p`font-size: 8px; font-weight: 600; color: #0f172a;`;
const Popular = styled.span`
   font-size: 5px; font-weight: 700; background: #0f172a; color: white;
   padding: 1px 3px; border-radius: 2px; margin-left: 2px;
`;
const Duration = styled.span`font-size: 8px; color: #475569;`;
const Price = styled.span`font-size: 9px; font-weight: 700; color: #0f172a;`;
const Btn = styled.div`
   font-size: 7px; font-weight: 600; color: #0f172a; text-align: center;
   border: 1px solid #0f172a; border-radius: 3px; padding: 2px 4px;
`;
const BtnFilled = styled.div`
   font-size: 7px; font-weight: 600; color: white; text-align: center;
   background: #0f172a; border-radius: 3px; padding: 2px 4px;
`;

export default ProfessionalTheme;
